export const scrollToId = (id) => {
  const el = document.querySelector(id);
  if (!el) return false;
  el.scrollIntoView({ behavior: "instant", block: "start" });
  return true;
};

export const goTool = (navigate) => {
  if (window.location.pathname !== "/") {
    navigate("/", { state: { scrollTool: true } });
  } else {
    scrollToId("#tool");
  }
};

export const formatHours = (minutes) => {
  const h = Math.floor(minutes / 60);
  if (h >= 1000) return `${(h / 1000).toFixed(1)}k`;
  return h.toLocaleString("en-US");
};
